export default __webpack_public_path__ + "static/media/Flag_of_El_Salvador.6f041473.svg";